export const LETTER = '/letter/'
export const LETTER_INCOMING = `${LETTER}incoming` as const
export const LETTER_OUTGOING = `${LETTER}outgoing` as const
export const LETTER_STATUS = `${LETTER}status` as const
export const LETTER_PUBLIC_INFO = '/public/outgoing_letter'
